import wintradoDevConfig from './wintrado.dev';
import getFullConfigFromBrandConfig from './base';
const config = getFullConfigFromBrandConfig(wintradoDevConfig, 'dev');
export default config;
